import React from "react";
import { useNavigate } from "react-router-dom";
import "./Panier.css";
import { usePanier, Outil, outilListe } from "../PanierContext";

interface PanierProps {
  closeSideBar: () => void;
  onOpenCommande: () => void; // ✅ ajout
}

const Panier: React.FC<PanierProps> = ({ closeSideBar, onOpenCommande }) => {
  const { panier, setPanier, livraison } = usePanier();
  const navigate = useNavigate();

  // 🔹 Trouver un outil par id
  const getOutil = (idOutil: number): Outil | undefined =>
    outilListe.find((outil) => outil.id === idOutil);

  // 🔹 Supprimer complètement un outil
  const handleSupprimer = (idOutil: number) => {
    setPanier((prev) => prev.filter((el) => el.idOutil !== idOutil));
  };

  // 🔹 Incrémenter la quantité
  const handleIncrement = (idOutil: number) => {
    setPanier((prev) =>
      prev.map((el) =>
        el.idOutil === idOutil ? { ...el, nombre: el.nombre + 1 } : el
      )
    );
  };

  // 🔹 Décrémenter la quantité
  const handleDecrement = (idOutil: number) => {
    setPanier((prev) =>
      prev
        .map((el) =>
          el.idOutil === idOutil ? { ...el, nombre: el.nombre - 1 } : el
        )
        .filter((el) => el.nombre > 0)
    );
  };

  // 🔹 Calcul du total
  const total = panier.reduce((acc, item) => {
    const outil = getOutil(item.idOutil);
    return outil ? acc + outil.prix * item.nombre : acc;
  }, 0);

  // 🔹 Redirection vers /outils + fermeture
  const handleVoirOutils = () => {
    closeSideBar();
    navigate("/outils");
  };

  return (
    <div className="panier">
      {panier.length === 0 ? (
        <div className="panier-vide-container">
          <h3 className="panier-vide">Oups ! Ton panier est vide !</h3>
          <button className="retour-outil-btn" onClick={handleVoirOutils}>
            🛠️ Voir la boutique
          </button>
        </div>
      ) : (
        <>
          {panier.map((item, index) => {
            const outil = getOutil(item.idOutil);
            if (!outil) return null;

            return (
              <React.Fragment key={outil.id}>
                <div className="panier-item">
                  <div className="titre">{outil.nom}</div>
                  <img src={outil.image} alt={outil.nom} className="panier-image" />
                  <div className="description">{outil.description}</div>

                  <div className="quantite">
                    <button onClick={() => handleDecrement(outil.id)}>-</button>
                    <span>{item.nombre}</span>
                    <button onClick={() => handleIncrement(outil.id)}>+</button>
                  </div>

                  <div className="prix">
                    <h3>{((outil.prix * item.nombre) / 100).toFixed(2)} €</h3>
                  </div>

                  <button
                    className="supprimer-btn"
                    onClick={() => handleSupprimer(outil.id)}
                    title="Supprimer"
                  >
                    ✖
                  </button>
                </div>

                {index < panier.length - 1 && <hr className="separateur" />}
              </React.Fragment>
            );
          })}

          {/* Frais de livraison */}
          <div className="panier-item">
            <div className="titre">Frais de livraison</div>
            <div className="prix">
              <h3>{livraison.toFixed(2)} €</h3>
            </div>
          </div>


          <div className="total-panier">
            <h3>Total : {((total / 100)+livraison).toFixed(2)} €</h3>
          </div>

          {/* ✅ Bouton pour ouvrir la modale commande */}
          <div className="valider-commande-container">
            <button
              className="valider-commande-btn"
              onClick={() => {
                closeSideBar(); // ferme la sidebar
                onOpenCommande(); // ouvre la modale commande
              }}
            >
              🧾 Passer la commande
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Panier;
